module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.auth && _vm.dataLoaded) ? _c('div', [(_vm.auth && _vm.dataLoaded) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'loading-screen': true, 'show-loading': _vm.apiBusy
    }
  }, [_c('div', {
    staticClass: "loading"
  }, [_vm._v("\n        Working...\n      ")])]), _vm._v(" "), (!_vm.showPrint) ? _c('section', {
    staticClass: "section"
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "name": "page-fade-up"
    }
  }, [_c('router-view')], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPrint) ? _c('print-dialog', {
    attrs: {
      "type": _vm.printType,
      "contents": _vm.printContents
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "preloading"
  }, [_c('loader')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01b4ca22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/App.vue
// module id = 491
// module chunks = 0